import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRoles = []
}) => {
  const { isAuthenticated, isLoading, hasAnyRole } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <Dimmer active>
        <Loader size="large">Verificando autenticação...</Loader>
      </Dimmer>
    );
  }

  // Se não está autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se há roles requeridas e usuário não tem nenhuma delas
  if (requiredRoles.length > 0 && !hasAnyRole(requiredRoles)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
        <h2>Acesso Negado</h2>
        <p>Você não tem permissão para acessar esta página.</p>
        <p>Roles requeridas: {requiredRoles.join(', ')}</p>
      </div>
    );
  }

  // Tudo OK, renderizar children
  return <>{children}</>;
};

export default ProtectedRoute;
